export const extractValueFromClass = (prefix: string, className: string) => {
    const match = className.match(new RegExp(`${prefix}-\\[(.*)\\]`));
    return match ? match[1] : undefined;
};
